const redirect = (to, {push}, self) => to.includes("http")  || !push
                                    ? window.open(to, self ? "_self": null)
                                    : push(to);

export default redirect